export class TranslateLanguageGroupItem {
  idTranslateLanguageGroupItem: number;
  idLanguageGroupItem: number;
  idLanguage: number;
  text: string;
  locked: boolean;

  constructor(
    idTranslateLanguageGroupItem: number,
    idLanguageGroupItem: number,
    idLanguage: number,
    text: string,
    locked: boolean,
  ) {
    this.idTranslateLanguageGroupItem = idTranslateLanguageGroupItem;
    this.idLanguageGroupItem = idLanguageGroupItem;
    this.idLanguage = idLanguage;
    this.text = text;
    this.locked = locked;
  }

  static fromRaw(raw: any): TranslateLanguageGroupItem {
    return new TranslateLanguageGroupItem(
      Number(raw.idTranslateLanguageGroupItem),
      Number(raw.idLanguageGroupItem),
      Number(raw.idLanguage),
      String(raw.text),
      Boolean(raw.locked),
    );
  }

  clone(): TranslateLanguageGroupItem {
    return new TranslateLanguageGroupItem(
      this.idTranslateLanguageGroupItem,
      this.idLanguageGroupItem,
      this.idLanguage,
      this.text,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idLanguageGroupItem: this.idLanguageGroupItem,
      idLanguage: this.idLanguage,
      text: this.text,
    };
    if (this.idTranslateLanguageGroupItem !== 0) {
      payload.idTranslateLanguageGroupItem = this.idTranslateLanguageGroupItem;
    }
    return payload;
  }
}
